import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "react-query";
import { api } from "services/api";
import { EditSupportAgentData, SupportAgent } from "types/SupportAgent";
import { axiosError, axiosSuccess, handleRequestError, handleRequestSuccess } from "utils/Request";

async function editSupportAgent(agent: SupportAgent, data: EditSupportAgentData) {
  const { data: response } = await api.put(`/support/agents/${agent.id}`, data).then(axiosSuccess).catch(axiosError);
  return response;
}

export function useEditSupportAgent() {
  const queryClient = useQueryClient();

  return useMutation(({ agent, data }: { agent: SupportAgent; data: EditSupportAgentData }) => editSupportAgent(agent, data), {
    onSuccess: () => {
      handleRequestSuccess('Agente atualizado com sucesso!');
      queryClient.invalidateQueries('support-agents');
      queryClient.invalidateQueries('support-stats');
    },
    onError: (error: AxiosError) => {
      handleRequestError(error, 'Erro ao atualizar agente. Tente novamente.');
    },
  });
}
